// Page with a table that shows all documents w/ number of alerts in a sortable table

import React from 'react'
import AllAlertsTable from './AllAlertsTable'
import usePageTitle from '../../../util/usePageTitle'

const AllAlertsPage: React.FC = () => {
  usePageTitle('All Alerts')
  return <AllAlertsTable />
}

export default AllAlertsPage
